var _rect, _g;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgClockLoader10 = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_3041",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_3041)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 36.6666C17.6944 36.6666 15.5278 36.2291 13.5 35.3541C11.4722 34.4791 9.70833 33.2916 8.20833 31.7916C6.70833 30.2916 5.52083 28.5278 4.64583 26.5C3.77083 24.4722 3.33333 22.3055 3.33333 20C3.33333 17.6944 3.77083 15.5278 4.64583 13.5C5.52083 11.4722 6.70833 9.70831 8.20833 8.20831C9.70833 6.70831 11.4722 5.52081 13.5 4.64581C15.5278 3.77081 17.6944 3.33331 20 3.33331C22.3055 3.33331 24.4722 3.77081 26.5 4.64581C28.5278 5.52081 30.2917 6.70831 31.7917 8.20831C33.2917 9.70831 34.4792 11.4722 35.3542 13.5C36.2292 15.5278 36.6667 17.6944 36.6667 20C36.6667 22.3055 36.2292 24.4722 35.3542 26.5C34.4792 28.5278 33.2917 30.2916 31.7917 31.7916C30.2917 33.2916 28.5278 34.4791 26.5 35.3541C24.4722 36.2291 22.3055 36.6666 20 36.6666ZM20 33.3333C23.7222 33.3333 26.875 32.0416 29.4583 29.4583C32.0417 26.875 33.3333 23.7222 33.3333 20C33.3333 18.2222 33 16.5139 32.3333 14.875C31.6667 13.2361 30.7083 11.7916 29.4583 10.5416L20 20V6.66665C16.2778 6.66665 13.125 7.95831 10.5417 10.5416C7.95833 13.125 6.66666 16.2778 6.66666 20C6.66666 23.7222 7.95833 26.875 10.5417 29.4583C13.125 32.0416 16.2778 33.3333 20 33.3333Z",
    fill: "#008908"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgClockLoader10, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/clock_loader_10.bb3054f9.svg";
export { ForwardRef as ReactComponent };